/* eslint-disable */
import React, {useState} from "react";
import {Button, Form, Input, message, Modal} from "antd";
import {useAuth} from "../../providers/AuthProvider";
import {useNavigate} from "react-router-dom";
import {md5} from "js-md5";
import "./index.css";
// import "../../wxLogin.js";
import logo from "../../static/cn_logo2.png";
import {getPhoneCode, resetPasswordByEmail, resetPasswordByPhone, TriggerEmailApi} from "../../api/Api";


function ForgetPassword() {
	const [form] = Form.useForm();
	const {setNewToken} = useAuth();
	const navigate = useNavigate();
	const [codeVisible, setCodeVisible] = useState<boolean>(false);
	const [disabled, setDisabled] = useState(false);
	const [countdown, setCountdown] = useState(60);
	const handleSubmit = async (values: any) => {
		if (values?.emailOrPhoneNumber.includes("@")) {
			try {
				const res = await resetPasswordByEmail({
					email: values?.emailOrPhoneNumber,
					code: values?.code,
					password: md5(values?.password)
				});
				if (res) {
					message.success("success");
				}
			} catch (e) {
				message.error("error");
			}
		} else {
			try {
				const res = await resetPasswordByPhone({
					phoneNumber: values?.emailOrPhoneNumber,
					code: values?.code,
					password: md5(values?.password)
				});
				if (res) {
					message.success("success");
				}
			} catch (e) {
				message.error("error");
			}
		}
	};


	const getCode = async () => {
		const emailOrPhoneNumber = form.getFieldValue("emailOrPhoneNumber");
		if (!emailOrPhoneNumber) {
			message.error("请输入手机号或邮箱！");
			return;
		}
		setDisabled(true);
		let timeLeft = 60;
		const timer = setInterval(() => {
			timeLeft -= 1;
			setCountdown(timeLeft);
			if (timeLeft <= 0) {
				clearInterval(timer);
				setDisabled(false);
				setCountdown(60);
			}
		}, 1000);
		if (emailOrPhoneNumber.includes("@")) {
			//邮箱
			try {
				const res = await TriggerEmailApi({
					email: emailOrPhoneNumber,
				});
				if (res) {
					message.success("send successful.");
				}
			} catch (e: any) {
				message.error("send failed");
				clearInterval(timer);
				setDisabled(false);
				setCountdown(60);
			}

		} else {
			//手机号
			try {
				const res = await getPhoneCode({
					phoneNumber: emailOrPhoneNumber,
				});
				if (res) {
					message.success("send successful.");
				}
			} catch (e: any) {
				message.error("send email failed.");
				clearInterval(timer);
				setDisabled(false);
				setCountdown(60);
			}
		}
	}


	const onFinishFailed = (errorInfo: any) => {
		console.log("Failed:", errorInfo);
	};


	const handleOk = () => {
		setCodeVisible(false);
	};

	const handleCancel = () => {
		setCodeVisible(false);
	};
// @ts-ignore
// @ts-ignore
	return (
		<div className="login-wrapper">
			{/* <div id="login_container"></div> */}

			<Modal
				// title="Basic Modal"
				open={codeVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<div id="login_container"></div>
			</Modal>
			<div className="glow-bg-2"></div>
			<div className="login-wrapper-main">
				<div className="header">
					<img src={logo}/>
				</div>
				<div className="login-left-wrapper">
					<div className="login-left">
						<div className="login-left-top">
							<div className="login-left-top-gradient">
								欢迎使用 点灵数据搜集平台
							</div>
							<div className="login-left-top-subtitle">
								第五维度打造的点灵数据搜集平台，是一款高效数据获取工具 <br/>
								以对话的形式，提供文本、图片等数据跨模态检索，并支持互联网公开数据和私有数据部署
								<br/>
								为AI模型训练提供高质量数据
								<br/>
							</div>
						</div>
						<div className="login-left-title-wrapper">
							<video
								width="100%"
								controls
								autoPlay
								muted
								style={{
									border: "none",
									outline: "none",
									borderRadius: "10px",
								}}
							>
								<source src="../../datagptdemo.mp4" type="video/mp4"/>
								Your browser does not support the video tag.
							</video>
						</div>
					</div>
				</div>
				<div className="dlp">
					<div className="login-card-wrapper">
						<div className="login-card-wrapper-up">
							<div className="login-card-header">
								<div className="login-card-title">找回密码</div>
								<div className="login-card-subtitle">
									欢迎登录杭州五维数据有限责任公司
								</div>
							</div>
							<Form
								form={form}
								name="basic"
								layout="vertical"
								initialValues={{remember: true}}
								onFinish={handleSubmit}
								onFinishFailed={onFinishFailed}
								autoComplete="off"
							>
								<Form.Item
									label="邮箱或手机号"
									name="emailOrPhoneNumber"
									rules={[
										{required: true, message: "Please input your username!"},
									]}
								>
									<Input style={{height: "40px", width: "95%"}}/>
								</Form.Item>


								<Form.Item label="验证码" required>
									<Input.Group compact>
										<Form.Item
											name="code"
											noStyle
											rules={[{required: true, message: "Please input your code!"}]}
										>
											<Input
												style={{height: "40px", width: "65%"}}
											/>
										</Form.Item>
										<Button
											type="primary"
											style={{height: "40px", width: "30%"}}
											onClick={getCode}
											disabled={false}
										>
											{disabled ? `${countdown}s` : "获取验证码"}
										</Button>

									</Input.Group>
								</Form.Item>


								<Form.Item
									label="新密码"
									name="password"
									rules={[
										{required: true, message: "Please input your password!"},
									]}
									style={{marginBottom: "10px"}}
								>
									<Input.Password style={{height: "40px", width: "95%"}}/>
								</Form.Item>
								<Form.Item
									label={null}
									style={{textAlign: "center", marginTop: 30}}
								>
									<Button
										type="primary"
										htmlType="submit"
										className="submit-btn"
									>
										确认
									</Button>
								</Form.Item>
								<div className="login-more">
									<a href="/">返回登录</a>
								</div>
							</Form>
						</div>
						<div className="login-more-confirm">
							登录即代表同意
							<a href="/docs?tab=userpolicy">《用户协议》</a>和
							<a href="/docs?tab=privacy">《产品隐私协议》</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default ForgetPassword;
